<div class="row">
  @if (!utilService.isMobile() && !f_type) {
    <div class="page-title-container d-flex">
      <div class="page-title flex-grow-1 ">
        <div class="mb-0 ">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2 ">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                <img src="assets/images/grid-back.png"></a>
              </div>
              <div class="">{{'pagename.add.service_booking' | translate | async }} </div>
            </div>
          </div>
        </div>
        <div class="component-container "></div>
      </div>
    }
    @if (resourceDef && !f_type) {
      <div class="col-sm-12">
        <!-- {{dialogConfig.data|json}} -->
        <dhs-form (getData)="getDataFn($event)" [action]="'ADD'" [config]="config"
          [fieldGroup]="resourceDef.form" [decorator]="dec_p"
          (questionValueChanged)="questionValueChanged($event)" [customButton]='btn'>
        </dhs-form>
      </div>
    }
    @if (resourceDef && f_type) {
      <div class="col-sm-12">
        <dhs-form (getData)="getDataFn($event)" [action]="'ADD'" [config]="config" [formtype]="f_type" [customButton]='btn'
          [fieldGroup]="resourceDef.form" [decorator]="decorator_nm" (saveFinished)="onSaveFinished($event)"
          (questionValueChanged)="questionValueChanged($event)" [customButton]='btn'>
        </dhs-form>
      </div>
    }
    @if (f_type && due_api_data != null) {
      <div class="col-sm-12">
        @if (due_api_data != null) {
          <dhs-data-grid [fields]="dueResDef.list.fields" [data]="due_api_data" [bulkActionsConfig]="_currentData.bulkAction"
            (configValues)="getConfigValues($event)" [rowClick]="_currentData.rowClick" (bulkActionClicked)="onBulkActionClicked($event)" (bannerRefreshClick)="refreshGridBanner($event);" (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)" (editEllipseClick)="buttonAction($event)" (onPageChanges)="pageChanges($event)"
            (onSortChanges)="sortChanges($event);" [config]="configApproval">
          </dhs-data-grid>
        }
      </div>
    }
    @if (serviceType == 'serviceItemName' || serviceType == 'specialityId') {
      <div class="col-sm-12">
        @if (serviceItemId != '') {
          <div class="">
            <div class="col-12 p-0 mt-4 text-center">
              <button type="submit" class="primary-btn" (click)="get_data(form)">View Count
              </button>
            </div>
          </div>
        }
        @if (serviceItemId != '' && viewCount== true && resourceDef1) {
          <dhs-data-grid [fields]="resourceDef1.list.fields" [data]="_currentData.dataList" [bulkActionsConfig]="_currentData.bulkAction"
            (configValues)="getConfigValues($event)" [rowClick]="_currentData.rowClick" (bulkActionClicked)="onBulkActionClicked($event)" (bannerRefreshClick)="refreshGridBanner($event);" (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)" (editEllipseClick)="buttonAction($event)" (onPageChanges)="pageChanges($event)"
            (onSortChanges)="sortChanges($event);" [config]="_currentData.dataGridConfig">
          </dhs-data-grid>
        }
      </div>
    }
    @if (_currentData.currentAction === 'ADD' && _layout_id == 'split_bill_details') {
      <div class="col-12 p-0 mt-4 text-center">
        <button type="submit" class="primary-btn" (click)="get_data(form)">View Count
        </button>
      </div>
    }
    @if (!f_type) {
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4">
        <button type="button" class="primary-btn" (click)="createBill('createBill')">
          Submit
          <i aria-hidden="true" class="fa fa-save ml-2"></i>
        </button>
      </div>
    }
  </div>